import { Stack } from '@tonic-one/react';
import { useCallback, useMemo } from 'react';
import {
  ConditionDefinition,
  ConditionLogicOperator,
  CorrelatedExpressionCondition,
} from '../types';
import ConditionEditor from './ConditionEditor';

const ExpressionContentEditor = (props: {
  allConditions: ConditionDefinition[];
  selectedConditions: CorrelatedExpressionCondition[];
  conditionLogic: ConditionLogicOperator;
  onChange: (conditions: CorrelatedExpressionCondition[]) => void;
  isEmailLoop?: boolean;
}) => {
  const { allConditions, selectedConditions, onChange, isEmailLoop } = props;

  const handleConditionChange = useCallback(
    (condition: CorrelatedExpressionCondition, index: number) => {
      const newConditions = [...selectedConditions];
      newConditions[index] = condition;
      onChange(newConditions);
    },
    [selectedConditions, onChange]
  );

  const conditionDefinitionsMap = useMemo(() => {
    return (allConditions ?? []).reduce(
      (acc, c) => {
        acc[c.raiCondId] = c;
        return acc;
      },
      {} as Record<string, ConditionDefinition>
    );
  }, [allConditions]);

  return (
    <Stack gap="2x">
      {selectedConditions.map((condition, index) => (
        <ConditionEditor
          key={`${condition.id}-${index}`}
          condition={condition}
          conditionDefinitionsMap={conditionDefinitionsMap}
          onChange={(condition) => handleConditionChange(condition, index)}
          isEmailLoop={isEmailLoop}
        />
      ))}
    </Stack>
  );
};

export default ExpressionContentEditor;
